import { BaseError } from './BaseError'
import { ErrorItem } from './types'

export const DefaultError = ({ error }: { error: ErrorItem }) => (
  <BaseError error={error} />
)
